import { useMemo } from 'react';

import { Feedback } from '@bonusly/common-feedback';

import { Bonus } from '../../../../../../types/bonus';
import { BonusReference, FeedbackReference, References } from '../types';

export const useOrderedReferences = (bonuses?: Bonus[], feedback?: Feedback[]): References[] => {
	return useMemo(() => {
		const mappedBonuses = (bonuses || []).map(
			(bonusItem): BonusReference => ({
				type: 'bonus',
				item: bonusItem,
				createdAt: new Date(bonusItem.created_at), // I don't like this, but Bonus and Feedback have different createdAt fields
			})
		);

		const mappedFeedback = (feedback || []).map(
			(feedbackItem): FeedbackReference => ({
				type: 'feedback',
				item: feedbackItem,
				createdAt: feedbackItem.createdAt,
			})
		);

		return [...mappedBonuses, ...mappedFeedback].sort((a, b) => {
			return b.createdAt.getTime() - a.createdAt.getTime();
		});
	}, [bonuses, feedback]);
};
